import { DurationIcon, MoneyBackIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import { isClaimStatus, isProcessedClaimStatus } from "common";
import React from "react";
import { ExperiencePurchaseItem, PurchaseItem } from "types";

interface CancellationProtectionBadgeProps {
    item?: PurchaseItem;
}

export const CancellationProtectionBadge = ({ item }: CancellationProtectionBadgeProps) => {
    const status = (item as ExperiencePurchaseItem | undefined)?.cancellationProtection?.status;

    if (!isClaimStatus(status)) {
        return null;
    }

    const isProcessed = isProcessedClaimStatus(status);

    return (
        <Badge
            color={isProcessed ? "success" : "warning"}
            size="medium"
            icon={
                isProcessed ? (
                    <MoneyBackIcon size="medium" className="text-success" />
                ) : (
                    <DurationIcon size="medium" className="text-warning-dark" />
                )
            }
            data-testid="cancellation-protection-claim-badge"
        >
            {isProcessed ? "Refund Processed" : "Claim Submitted"}
        </Badge>
    );
};
